module.exports = __webpack_public_path__ + "static/media/nubesBackgroundLogin.45436a92.svg";